import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";


export const exportApiRepository = {
    useGetList: function (args) {
        return useQuery({
            queryKey: ['admin', 'export', 'search', args],
            queryFn: () => generalRequest.get(`/admin/exports`, {params: args}),
        })
    },
    useCreateNewExport: function () {
        return useMutation({
            mutationFn: (data) =>
                generalRequest.post(`/admin/exports`, data)
        });
    },
    useDeleteExport: function () {
        return useMutation({
            mutationFn: (data) =>
                generalRequest.delete(`/admin/exports/${data?.id}`)
        });
    }

}

